var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rbx-text-editor"},[_c('div',{staticClass:"rbx-text-editor-title"},[_vm._v(_vm._s(_vm.label))]),_c('div',{ref:"editor",staticClass:"rbx-text-editor-content"})])}
var staticRenderFns = []

export { render, staticRenderFns }